import script from "./YwPage.vue?vue&type=script&setup=true&name=YwPage&lang=js"
export * from "./YwPage.vue?vue&type=script&setup=true&name=YwPage&lang=js"

import "./YwPage.vue?vue&type=style&index=0&id=2c5cfe6e&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c5cfe6e"]])

export default __exports__